import { useQuery } from '@apollo/client';
import { GET_PDA_HOME_MENU_PAGE_LIST } from '../graphql/queries';

interface PdaHomeMenuListItem {
  groupId: string;
  warehouseId: number;
  warehouseName: string;
  accountRole: string;
}

interface PdaHomeMenuPageResponse {
  content: PdaHomeMenuListItem[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export const usePdaHomeConfigList = (
  warehouseId: number | null,
  role: string | null,
  page: number = 1,
  size: number = 50,
  t?: (key: string, params?: any) => string
) => {
  const { data, loading, refetch } = useQuery<{
    getPdaHomeMenuPageList: PdaHomeMenuPageResponse;
  }>(GET_PDA_HOME_MENU_PAGE_LIST, {
    variables: {
      filters: {
        warehouseId,
        accountRole: role,
      },
      pageRequest: {
        page,
        size,
        sortBy: 'warehouseId',
        sortDirection: 'DESC',
      },
    },
    fetchPolicy: 'network-only',
  });

  return {
    configs: data?.getPdaHomeMenuPageList?.content || [],
    totalElements: data?.getPdaHomeMenuPageList?.totalElements || 0,
    loading,
    refetch,
  };
};
